import { render, staticRenderFns } from "./AddComponentCard2.vue?vue&type=template&id=557e0b9a&scoped=true&"
import script from "./AddComponentCard2.vue?vue&type=script&lang=js&"
export * from "./AddComponentCard2.vue?vue&type=script&lang=js&"
import style0 from "./AddComponentCard2.vue?vue&type=style&index=0&id=557e0b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e0b9a",
  null
  
)

export default component.exports